export default "__VITE_ASSET__42bdd4ae__"